import React, { Component } from 'react';
import { drapcodeIcon } from '../../common/custom/icon-library';
import { getBuilderURL } from '../../common/utils/builder-url-util';
import cookie from 'react-cookies';
import { Mixpanel } from '../../common/utils/mixpanelUtil';
import ParentDocCard from '../common/ParentDocCard';
import CardTitleHeader from '../../common/ui/CardTitleHeader';
export default class ProjectOnBoardFinal extends Component {
  static propTypes = {};

  openEditor = () => {
    const { projectId, version } = this.props.match.params;
    let token = cookie.load('token');
    if (!token) {
      token = '';
    }
    Mixpanel.track('Clicked on- Lets Start Building your App on onboarding final step');
    const redirectUrl = getBuilderURL();
    window.location.href = `${redirectUrl}editor/${version}/v/${projectId}/loader?token=${token}`;
  };

  render() {
    return (
      <div className="main">
        <div className="section">
          <div className="container">
            <div className="row mx-auto">
              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
                <div className="card">
                  <div
                    className="card-header card-header-icon"
                    data-background-color="drapcode-violet"
                  >
                    <i className={`wb ${drapcodeIcon('appSettings')}`}></i>
                  </div>
                  <div className="card-content">
                    <CardTitleHeader title="Where to go next?" />
                    <div className="row">
                      <div className="col-md-4 col-lg-4 col-sm-12 col-xs-12"></div>
                      <div className="col-md-4 col-lg-4 col-sm-12 col-xs-12 text-center">
                        <img src={require('./open-builder-1.png')} className="img-fluid" />
                      </div>
                      <div className="col-md-4 col-lg-4 col-sm-12 col-xs-12"></div>
                      <div className="col-md-1 col-lg-1 col-sm-12 col-xs-12"></div>
                      <div className="col-md-10 col-lg-10 col-sm-12 col-xs-12 text-center">
                        Kudos! You have successfully completed all the basic steps. Now, you can
                        dive straight into the building process. So, hit the button below & start
                        building your web app. Best of luck!
                        <br />
                        <br />
                        <button className="btn btn-lg btn-theme-submit" onClick={this.openEditor}>
                          Lets Start Building your App
                        </button>
                      </div>
                      <div className="col-md-1 col-lg-1 col-sm-12 col-xs-12"></div>
                    </div>
                  </div>
                </div>
              </div>
              <ParentDocCard></ParentDocCard>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
